import http from "./httpService";
const apiUrl = require("../config.json").apiUrl;


export const getTripHistory = (data) => {
    const apiEndPoint = `${apiUrl}/BoatBookedTicketPublicUser`;
    return http.post(`${apiEndPoint}`,data);
  };